//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const SectionService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveSection: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/section/edit/save", vo, successCallback, failureCallback);
    }
};

export default SectionService;